import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AuthProvider } from "app/contexts/FirebaseAuthContext";
import { SettingsProvider } from "app/contexts/SettingsContext";
import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
import { MatxTheme } from "./components";
import store from "./redux/store";
import routes from "./routes";
import "../fake-db";
import TitleProvider from "./contexts/titleContext";

const App = () => {
  const content = useRoutes(routes);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Provider store={store}>
        <SettingsProvider>
          <TitleProvider>
            <MatxTheme>
              <AuthProvider>{content}</AuthProvider>
            </MatxTheme>
          </TitleProvider>
        </SettingsProvider>
      </Provider>
    </LocalizationProvider>
  );
};

export default App;
